import React, { memo } from 'react';
import { CheckCircle2Icon, StarIcon } from 'lucide-react';
export function BenefitsSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-10 md:py-14 px-4 bg-[#eef6ff] border-y border-blue-100" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3">
          {/* Ideal Para */}
          <div className="bg-white rounded-2xl p-6 shadow-xl border border-gray-100" data-id="element-4">
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4 border-b-2 border-blue-500 pb-2 inline-block" data-id="element-5">
              Ideal para
            </h3>
            <ul className="space-y-3" data-id="element-6">
              <li className="flex items-start" data-id="element-7">
                <StarIcon className="w-5 h-5 text-yellow-400 mr-2 flex-shrink-0 mt-0.5 fill-yellow-400" data-id="element-8" />
                <span className="text-base font-medium text-gray-700" data-id="element-9">
                  Mamás y papás de niños de 1 a 3 años
                </span>
              </li>
              <li className="flex items-start" data-id="element-10">
                <StarIcon className="w-5 h-5 text-yellow-400 mr-2 flex-shrink-0 mt-0.5 fill-yellow-400" data-id="element-11" />
                <span className="text-base font-medium text-gray-700" data-id="element-12">
                  Abuelos/as que quieren actividades para compartir
                </span>
              </li>
              <li className="flex items-start" data-id="element-13">
                <StarIcon className="w-5 h-5 text-yellow-400 mr-2 flex-shrink-0 mt-0.5 fill-yellow-400" data-id="element-14" />
                <span className="text-base font-medium text-gray-700" data-id="element-15">
                  Docentes de nivel inicial y jardín maternal
                </span>
              </li>
              <li className="flex items-start" data-id="element-16">
                <StarIcon className="w-5 h-5 text-yellow-400 mr-2 flex-shrink-0 mt-0.5 fill-yellow-400" data-id="element-17" />
                <span className="text-base font-medium text-gray-700" data-id="element-18">
                  Quienes buscan estimulación temprana sin gastar una fortuna
                </span>
              </li>
            </ul>
          </div>

          {/* Beneficios */}
          <div className="bg-blue-600 rounded-2xl p-6 shadow-xl text-white" data-id="element-19">
            <h3 className="text-2xl font-extrabold mb-4 border-b-2 border-white/30 pb-2 inline-block" data-id="element-20">
              Beneficios de estos 6 libros
            </h3>
            <ul className="space-y-3" data-id="element-21">
              <li className="flex items-start" data-id="element-22">
                <CheckCircle2Icon className="w-5 h-5 text-green-300 mr-2 flex-shrink-0 mt-0.5" data-id="element-23" />
                <span className="text-base font-medium" data-id="element-24">
                  Estimular el desarrollo sensorial y motor
                </span>
              </li>
              <li className="flex items-start" data-id="element-25">
                <CheckCircle2Icon className="w-5 h-5 text-green-300 mr-2 flex-shrink-0 mt-0.5" data-id="element-26" />
                <span className="text-base font-medium" data-id="element-27">
                  Mejorar su lenguaje y vocabulario
                </span>
              </li>
              <li className="flex items-start" data-id="element-28">
                <CheckCircle2Icon className="w-5 h-5 text-green-300 mr-2 flex-shrink-0 mt-0.5" data-id="element-29" />
                <span className="text-base font-medium" data-id="element-30">
                  Potenciar atención, concentración y memoria
                </span>
              </li>
              <li className="flex items-start" data-id="element-31">
                <CheckCircle2Icon className="w-5 h-5 text-green-300 mr-2 flex-shrink-0 mt-0.5" data-id="element-32" />
                <span className="text-base font-medium" data-id="element-33">
                  Activar curiosidad, creatividad y percepción visual
                </span>
              </li>
              <li className="flex items-start" data-id="element-34">
                <CheckCircle2Icon className="w-5 h-5 text-green-300 mr-2 flex-shrink-0 mt-0.5" data-id="element-35" />
                <span className="text-base font-medium" data-id="element-36">
                  Reforzar el vínculo emocional entre vos y tu hijo/a
                </span>
              </li>
              <li className="flex items-start" data-id="element-37">
                <CheckCircle2Icon className="w-5 h-5 text-green-300 mr-2 flex-shrink-0 mt-0.5" data-id="element-38" />
                <span className="text-base font-medium" data-id="element-39">
                  Promover el aprendizaje sin pantallas
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-6 text-center" data-id="element-40">
          <button onClick={scrollToCompra} className="bg-orange-500 hover:bg-orange-600 text-white text-lg md:text-xl font-bold py-3 px-6 rounded-full shadow-[0_4px_14px_0_rgba(249,115,22,0.39)] transition-all duration-200 uppercase w-full max-w-lg mx-auto btn-pulse" data-id="element-41">
            🔥 ACCEDER AL KIT AHORA
          </button>
        </div>
      </div>
    </section>;
}